var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-placeholders-text"},_vm._l((_vm.lines),function(n){return _c('div',{key:n,staticClass:"content-placeholders-text__line"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }